import { render, staticRenderFns } from "./sub-total.vue?vue&type=template&id=860cf07a"
import script from "./sub-total.vue?vue&type=script&lang=js"
export * from "./sub-total.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports